<!-- @format -->
<div *ngIf="runtimeMode && (!sections || sections.length === 0)" class="logSheetNoFields">No fields configured for this workflow stage.</div>

<div *ngIf="!runtimeMode">
  <div class="container" *ngIf="!this.currentRoute.includes('/forms')">
      <button class="back-button" (click)="goBack()">&#8592;</button>
      <nav class="nav-pills">
        <div class="pill light">Dashboard</div>
        <span class="divider">></span>
        <div class="pill dark">Form</div>
      </nav>
    </div>
  <div [ngClass]="!this.currentRoute.includes('/forms') ? 'custom-section' : 'logSheet-section' " *ngIf="logSheet && logSheet['logSheetTemplated']">
  
  <div class="logSheet-title">
    <h1>
      {{
      logSheet["versionNumber"] > 0
      ? logSheet["logSheetTemplated"]["logSheetName"] +
      " V" +
      logSheet["versionNumber"]
      : logSheet["logSheetTemplated"]["logSheetName"]
      }}
    </h1>
    <div *ngIf="this.currentRoute.includes('/forms')">
      {{ activeVersion == 0 ? "Current" : "Previous" }}
      State
    </div>
    <button class="btn-fill logSheet-form-save-btn" (click)="saveLogSheet(true)"   *ngIf="!this.currentRoute.includes('/forms')">
      <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Save
    </button>
  </div>
  <div class="logSheet-details">
    <div>
      <span>Last Edited: {{ logSheet.lastModifiedDate | date: "medium" }}</span>
      <span *ngIf="this.currentRoute.includes('/forms')">Edit Count:
        {{ logSheet.nonAdminEditCount + logSheet.adminEditCount }}</span>
    </div>
    <div class="logSheet-details__btns">
      <button type="button" (click)="printPage()" *ngIf="this.currentRoute.includes('/forms')">
        <img src="../../../assets/print.svg" alt=" icon" />Print
      </button>

      <div *ngIf="logSheet.nonAdminEditCount + logSheet.adminEditCount >= 1">
        <button type="button" (click)="toggleVersions()">
          Versions
          <img src="../../../assets/down-arrow.svg" alt=" icon" />
        </button>
        <div *ngIf="isVersionMenuVisible" class="toggle-menu">
          <div *ngFor="let version of versions[0]['dataPointValue']; index as idx" (click)="setActiveVersion(idx)">
            <img [src]="
                activeVersion == idx
                  ? '../../../assets/active-checkbox.svg'
                  : '../../../assets/inactive-checkbox.svg'
                " alt=" checkbox" />
            <p>
              {{
              idx == 0
              ? "Current"
              : (version["lastModifiedDate"] | date: "medium")
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>

<div class="logSheet-form" [class.logSheet-form--page]="!runtimeMode" id="printsection" *ngIf="sections?.length > 0">
    <!-- Loop through sections -->
    <div *ngFor="let section of sections; index as sectionIdx" class="form-section">
      <!-- Section Header -->
      <div class="section-header">
        <h3 class="section-title">
          {{ section.name }}
          <span *ngIf="!isDynamicForm && section.isSubmitted" class="submitted-badge">Submitted</span>
        </h3>
        <button *ngIf="isDynamicForm && activeVersion == 0 && sections.length > 1" type="button"
          class="remove-section-btn" [disabled]="isDeleting" (click)="!isDeleting ? removeSection(section.id) : null"
          title="Remove Section">
          <span *ngIf="isDeleting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span *ngIf="!isDeleting">-</span>
          <!-- Remove Section -->
        </button>
      </div>

      <div style="padding: 10px" [ngClass]="runtimeMode ? 'runtime-field-rows' : 'field-rows'">
        <ng-container *ngFor="let dataPoint of section.dataPoints; index as idx">
          <!-- row break: starts a new builder-configured row -->
          <div *ngIf="runtimeMode && dataPoint['rowStart'] && idx > 0" class="runtime-row-break"></div>
        <div [ngClass]="runtimeMode ? runtimeFieldClasses(dataPoint) : 'field-cell'" [ngStyle]="dataPoint['hiddenByDefault'] == true? { display: 'none' }: {}">
          <div class="logSheet-form__datapoint" [ngClass]="dataPoint['dataType'] != 'Boolean' ? 'stretch' : 'space-between'"  #dpField [attr.data-id]="dataPoint['dataPointId']" [attr.data-section]="sectionIdx">
            <div>
              <div class="field-label-row">
                <label
                  [for]="'dp_' + sectionIdx + '_' + dataPoint['dataPointId']"
                  class="custom-label"
                  [class.required]="isFieldRequired(dataPoint)">
                  {{ dataPoint["dataPointName"] }}
                </label>
                <span *ngIf="!isFieldRequired(dataPoint)" class="field-optional-label">(Optional)</span>
              </div>
              <!-- TEXT (SHORT) -->
              <input
                *ngIf="dataPoint['dataType'] == 'Text (Short)'"
                maxlength="50"
                type="text"
                class="custom-input"
                [disabled]="isLocked(dataPoint)"
                [ngClass]="isLocked(dataPoint) ? 'disabled-input' : ''"
                [id]="'dp_' + sectionIdx + '_' + dataPoint['dataPointId']"
                [value]="section.dataPointValues[idx]['value']"
                [(ngModel)]="section.dataPointValues[idx]['value']"
                (ngModelChange)="onInputChange(sectionIdx); dataPoint['triggerConditions'] != null ? evaluateFieldCondition($event, dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']): ''"
                placeholder="Add Text"
              />
              <!-- BOOLEAN / TOGGLE -->
              <app-custom-switch
                *ngIf="dataPoint['dataType'] == 'Boolean'"
                [enabled]="section.dataPointValues[idx]['value'] === 'true'"
                [disabled]="isLocked(dataPoint)"
                (onToggle)="section.dataPointValues[idx]['value'] = $event ? 'true' : 'false'; onInputChange(sectionIdx); dataPoint['triggerConditions'] != null ? evaluateFieldCondition($event ? 'true' : 'false', dataPoint['dataType'], dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']) : ''">
              </app-custom-switch>
              <!-- DATE RANGE -->
              <div *ngIf="dataPoint['dataType'] == 'Date Range'" class="date-range-wrapper" style="display:flex; gap:1rem;">
                <div style="flex:1; display:flex; flex-direction:column;">
                  <label class="custom-label">{{ (dataPoint['listOptions'] || 'Start Date,End Date').split(',')[0] }}</label>
                  <input type="date" class="custom-input" [disabled]="isLocked(dataPoint)"
                    [ngClass]="isLocked(dataPoint) ? 'disabled-input' : ''"
                    [value]="(section.dataPointValues[idx]['value'] || '|').split('|')[0]"
                    (change)="setDateRangePart(sectionIdx, idx, 'start', $any($event.target).value)" />
                </div>
                <div style="flex:1; display:flex; flex-direction:column;">
                  <label class="custom-label">{{ (dataPoint['listOptions'] || 'Start Date,End Date').split(',')[1] }}</label>
                  <input type="date" class="custom-input" [disabled]="isLocked(dataPoint)"
                    [ngClass]="isLocked(dataPoint) ? 'disabled-input' : ''"
                    [value]="(section.dataPointValues[idx]['value'] || '|').split('|')[1]"
                    (change)="setDateRangePart(sectionIdx, idx, 'end', $any($event.target).value)" />
                </div>
              </div>
              <!-- TIMESTAMP (AUTO / SUBMITTED AT) -->
              <input *ngIf="dataPoint['dataType'] == 'Timestamp (Auto)'" type="text" class="custom-input disabled-input"
                readonly
                [value]="section.dataPointValues[idx]['value'] ? (section.dataPointValues[idx]['value'] | date: 'medium') : 'Auto-filled on submission'" />
              <!-- REFERENCE NUMBER (AUTO) -->
              <input *ngIf="dataPoint['dataType'] == 'Reference Number'" type="text" class="custom-input disabled-input"
                readonly
                [value]="section.dataPointValues[idx]['value'] || 'Auto-generated on submission'" />
              <!-- FILE UPLOAD -->
              <div *ngIf="dataPoint['dataType'] == 'File Upload'" class="file-upload-wrapper">
                <div class="uploaded-file-row"
                  *ngFor="let f of fileValueList(section.dataPointValues[idx]['value']); let fIdx = index">
                  <a class="uploaded-file-link" href="javascript:void(0)" (click)="downloadFile(f)">{{ f.name }}</a>
                  <button *ngIf="!isLocked(dataPoint)" type="button" class="file-remove-btn"
                    title="Remove file" (click)="removeDataPointFile(sectionIdx, idx, fIdx)">&times;</button>
                </div>
                <div class="file-upload-progress" *ngFor="let u of fileUploadsFor(sectionIdx, idx)">
                  <span class="fu-name">{{ u.name }}</span>
                  <div class="progress-bar-container"><div class="progress-bar" [style.width.%]="u.progress"></div></div>
                  <span class="fu-pct">{{ u.progress }}%</span>
                </div>
                <label class="upload-btn"
                  *ngIf="!isLocked(dataPoint) && !fileAtMax(dataPoint, sectionIdx, idx, section.dataPointValues[idx]['value'])">
                  <img src="../../assets/upload.svg" alt="" /> Upload file
                  <input type="file" hidden
                    [attr.accept]="fileAccept(dataPoint) || null"
                    [multiple]="fileAllowsMultiple(dataPoint)"
                    (change)="onDataPointFileSelected($event, sectionIdx, idx, dataPoint)" />
                </label>
                <p class="field-error-text" *ngIf="fileErrorFor(sectionIdx, idx)">{{ fileErrorFor(sectionIdx, idx) }}</p>
              </div>
              <!-- DURATION (reference-based: auto-computed, read-only, from two other date fields) -->
              <div *ngIf="dataPoint['dataType'] == 'Duration' && isReferenceDuration(dataPoint)"
                class="duration-auto-wrapper" style="display:flex; flex-direction:column;">
                <input type="text" class="custom-input disabled-input" readonly
                  [value]="computeReferenceDuration(section, dataPoint) || section.dataPointValues[idx]['value'] || 'Auto-calculated'" />
              </div>
              <!-- DURATION (self-contained: own start/end + computed result) -->
              <div *ngIf="dataPoint['dataType'] == 'Duration' && !isReferenceDuration(dataPoint)" class="date-range-wrapper"
                style="display:flex; gap:1rem; flex-wrap:wrap; align-items:flex-end;">
                <div style="flex:1; min-width:140px; display:flex; flex-direction:column;">
                  <label class="custom-label">Start Date</label>
                  <input type="date" class="custom-input" [disabled]="isLocked(dataPoint)"
                    [ngClass]="isLocked(dataPoint) ? 'disabled-input' : ''"
                    [value]="(section.dataPointValues[idx]['value'] || '|').split('|')[0]"
                    (change)="setDateRangePart(sectionIdx, idx, 'start', $any($event.target).value)" />
                </div>
                <div style="flex:1; min-width:140px; display:flex; flex-direction:column;">
                  <label class="custom-label">End Date</label>
                  <input type="date" class="custom-input" [disabled]="isLocked(dataPoint)"
                    [ngClass]="isLocked(dataPoint) ? 'disabled-input' : ''"
                    [value]="(section.dataPointValues[idx]['value'] || '|').split('|')[1]"
                    (change)="setDateRangePart(sectionIdx, idx, 'end', $any($event.target).value)" />
                </div>
                <div style="flex:1; min-width:140px; display:flex; flex-direction:column;">
                  <label class="custom-label">Duration ({{ dataPoint['listOptions'] || 'days' }})</label>
                  <input type="text" class="custom-input disabled-input" readonly
                    [value]="computeDuration(section.dataPointValues[idx]['value'], dataPoint['listOptions']) || 'Auto-calculated'" />
                </div>
              </div>
              <!-- LONG_TEXT -->
              <div *ngIf="dataPoint['dataType'] == 'Text (Long)'" class="long-text-wrapper">
                <textarea
                  maxlength="750"
                  class="custom-input"
                  rows="7"
                  [disabled]="isLocked(dataPoint)"
                  [ngClass]="isLocked(dataPoint) ? 'disabled-input' : ''"
                  [id]="'dp_' + sectionIdx + '_' + dataPoint['dataPointId']"
                  [value]="section.dataPointValues[idx]['value']"
                  (ngModelChange)="dataPoint['triggerConditions'] != null ?onLongTextChange($event, sectionIdx, idx, section, [dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']]): onLongTextChange($event, sectionIdx, idx, section)"
                  [(ngModel)]="section.dataPointValues[idx]['value']"
                  placeholder="Add Text (Long)"
                ></textarea>
                <div class="countdown-badge" [ngClass]="{ 'countdown-warning': (750 - countCharacters(section.dataPointValues[idx]['value'])) < 100 }">
                  {{ 750 - countCharacters(section.dataPointValues[idx]['value']) }}/750
                </div>
              </div>
              <!-- NUMBER -->
              <input *ngIf="dataPoint['dataType'] == 'Number'" type="number"
                onkeypress="return /^[0-9&.-]/g.test(event.key);" class="custom-input"
                [id]="'dp_' + sectionIdx + '_' + dataPoint['dataPointId']"
                [(ngModel)]="section.dataPointValues[idx]['value']"
                [value]="section.dataPointValues[idx]['value']"
                [disabled]="isLocked(dataPoint)"
                [ngClass]="isLocked(dataPoint) ? 'disabled-input' : ''"
                (ngModelChange)="onInputChange(sectionIdx); dataPoint['triggerConditions'] != null ? evaluateFieldCondition($event, dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']): ''"
                placeholder="Add Number"
              />

              <!-- List Fraction -->
              <div *ngIf="dataPoint['dataType'] == 'Fraction'" class="single-list">
                <div class="fraction-container">
                  <input
                    [disabled]="isLocked(dataPoint)"
                    [ngClass]="isLocked(dataPoint) ? 'disabled-input' : ''"
                    class="fraction-field"
                    type="number"
                    [value]="
                      extractNumerator(section.dataPointValues[idx]['value'])
                    " (change)="dataPoint['triggerConditions'] != null ?onNumeratorChange($event, idx, sectionIdx, [dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']]): onNumeratorChange($event, idx, sectionIdx)"
                    onkeypress="return /^[0-9&-]/g.test(event.key);" />
                  <div class="fraction-slash">/</div>
                  <input
                    [disabled]="isLocked(dataPoint)"
                    [ngClass]="isLocked(dataPoint) ? 'disabled-input' : ''"
                    class="fraction-field"
                    type="number"
                    [value]="
                      extractDenominator(section.dataPointValues[idx]['value'])
                    " (change)="dataPoint['triggerConditions'] != null ? onDenominatorChange($event, idx, sectionIdx, [dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']]): onDenominatorChange($event, idx, sectionIdx)"
                    onkeypress="return /^[0-9&-]/g.test(event.key);" />
                </div>
              </div>

              <!-- List Single Select -->
              <div *ngIf="dataPoint['dataType'] == 'List (Single Selection)'" class="single-list">
                <div *ngFor="
                    let listOption of (dataPoint['listOptions'] || '').split(',');
                    index as index
                  "
                  class="logSheet-form__datapoint__boolean logSheet-form__datapoint__single_list"
                >
                  <input
                    (click)="!isLocked(dataPoint) && handleSingleSelect(idx, listOption, sectionIdx); dataPoint['triggerConditions'] != null ? evaluateFieldCondition(listOption.trim(), dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']): ''" 
                    [checked]="
                      isSingleSelected(idx, listOption.trim(), sectionIdx)
                    " type="radio" [id]="'option_' + sectionIdx + '_' + index" [name]="
                      'option_' + sectionIdx + '_' + dataPoint['dataPointId']
                    "
                    [value]="listOption"
                    [disabled]="isLocked(dataPoint)"
                  />
                  <label [for]="'option_' + sectionIdx + '_' + index">{{
                    listOption
                    }}</label>
                </div>
              </div>

              <!-- Multiple Single Select -->
              <div *ngIf="dataPoint['dataType'] == 'List (Multiple Selection)'" class="multi-list">
                <div *ngFor="
                    let listOption of (dataPoint['listOptions'] || '').split(',');
                    index as index
                  " class="logSheet-form__datapoint__boolean">
                  <app-checked-box [index]="index" [label]="listOption" [icon]="
                      !isMultiSelected(idx, listOption.trim(), sectionIdx)
                        ? '../assets/checkbox-selected.svg'
                        : '../assets/checkbox-unselected.svg'
                    " (onClickIcon)="isLocked(dataPoint) ? null : (dataPoint['triggerConditions'] == null ? handleMultiSelect(idx, listOption.trim(), sectionIdx): handleMultiSelect(idx, listOption.trim(), sectionIdx, [dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']]))
                    ">
                  </app-checked-box>
                </div>
              </div>

              <!-- Dropdown List -->
              <select *ngIf="dataPoint['dataType'] == 'Dropdown List'" class="custom-input"
                [id]="'dp_' + sectionIdx + '_' + dataPoint['dataPointId']"
                [(ngModel)]="section.dataPointValues[idx]['value']"
                [disabled]="isLocked(dataPoint)"
                [ngClass]="isLocked(dataPoint) ? 'disabled-input' : ''"
                (ngModelChange)="onInputChange(sectionIdx); dataPoint['triggerConditions'] != null ? evaluateFieldCondition($event, dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']): ''"
              >
                <option value="" disabled selected>Select an option</option>
                <option *ngFor="let listOption of (dataPoint['listOptions'] || '').split(',')" [value]="listOption.trim()">
                  {{ listOption.trim() }}
                </option>
              </select>

              <!-- TIMESTAMP -->
              <div
                *ngIf="dataPoint['dataType'] == 'Timestamp'"
                class="logSheet-form__datapoint__timestamp"
              >
                <div
                  class="custom-input date-picker-container"
                  [ngClass]="isLocked(dataPoint) ? 'disabled-input' : ''"
                  [owlDateTimeTrigger]="dateTimePicker"
                >
                  <span
                    [ngClass]="
                      section.dataPointValues[idx]['value'] == ''
                        ? 'log-placeholder'
                        : ''
                    ">
                    {{
                    section.dataPointValues[idx]["value"] == ""
                    ? "Add date and time"
                    : section.dataPointValues[idx]["value"]
                    }}
                  </span>

                  <input
                    [id]="'dp_' + sectionIdx + '_' + dataPoint['dataPointId']"
                    [(ngModel)]="section.dataPointValues[idx]['value']"
                    [value]="section.dataPointValues[idx]['value']"
                    [owlDateTime]="dateTimePicker"
                    placeholder="Add Date and Time"
                    class="date-picker"
                    [disabled]="isLocked(dataPoint)"
                    (ngModelChange)="dataPoint['triggerConditions'] != null? dateTimeFormatter(section.dataPointValues[idx]['value'],idx,sectionIdx, [dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']]): dateTimeFormatter(section.dataPointValues[idx]['value'],idx,sectionIdx)"
                    [ngClass]="isLocked(dataPoint) ? 'disabled-input' : ''"
                    name="fromdate"
                  />
                </div>

                <owl-date-time #dateTimePicker [hour12Timer]="true"></owl-date-time>

                <button
                  type="button"
                  class="btn-fill"
                  [disabled]="isLocked(dataPoint)"
                  [ngClass]="isLocked(dataPoint) ? 'disabled-btn' : ''"
                  (click)="dataPoint['triggerConditions'] != null?setCurrentTimestamp(idx, sectionIdx, [dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']]): setCurrentTimestamp(idx, sectionIdx)"
                >
                  Current Timestamp
                </button>
              </div>

              <!-- GPS CAPTURE -->
              <div
                *ngIf="dataPoint['dataType'] == 'GPS Capture'"
                class="logSheet-form__datapoint__timestamp"
              >
                <div class="gps-capture-display custom-input"
                  [ngClass]="isLocked(dataPoint) ? 'disabled-input' : ''"
                >
                  <div *ngIf="section.dataPointValues[idx]['value'] == ''" class="gps-placeholder">
                    <span>Time: dd-MMM-yyyy 00:00 AM/PM</span>
                    <span>Coordinates: Latitude 0.0000, Longitude 0.0000</span>
                    <span>Altitude: N/A</span>
                    <span>Location: Unknown</span>
                  </div>
                  <div *ngIf="section.dataPointValues[idx]['value'] != ''" class="gps-data">
                    <span>Time: {{ getGpsField(section.dataPointValues[idx]['value'], 'time') }}</span>
                    <span>Coordinates: Latitude {{ getGpsField(section.dataPointValues[idx]['value'], 'lat') }}, Longitude {{ getGpsField(section.dataPointValues[idx]['value'], 'lng') }}</span>
                    <span>Altitude: {{ getGpsField(section.dataPointValues[idx]['value'], 'alt') }}</span>
                    <span>Location: {{ getGpsField(section.dataPointValues[idx]['value'], 'location') }}</span>
                  </div>
                </div>

                <button
                  type="button"
                  class="btn-fill"
                  [disabled]="isLocked(dataPoint)"
                  [ngClass]="isLocked(dataPoint) ? 'disabled-btn' : ''"
                  (click)="dataPoint['triggerConditions'] != null? captureGPS(idx, sectionIdx, [dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']]):captureGPS(idx, sectionIdx)"
                >
                  GPS Capture
                </button>
              </div>

              <!-- DATE -->
              <div *ngIf="dataPoint['dataType'] == 'Date'" class="logSheet-form__datapoint__timestamp">
                <div class="date-input-container">
                  <input type="text" class="custom-input date-manual-input"
                    [id]="'dp_manual_' + sectionIdx + '_' + dataPoint['dataPointId']"
                    [(ngModel)]="section.dataPointValues[idx]['value']"
                    (ngModelChange)="dataPoint['triggerConditions'] != null ? evaluateFieldCondition($event, dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']): ''"
                    placeholder="dd-MMM-yyyy"
                    [disabled]="isLocked(dataPoint)"
                    (blur)="dataPoint['triggerConditions'] != null ? validateManualDateInput(idx, sectionIdx, [dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']]):validateManualDateInput(idx, sectionIdx)"
                    [ngClass]="{
                      'disabled-input': isLocked(dataPoint),
                      'error-input': section.dataPointValues[idx]['dateFormatError']
                    }"
                  />
                  <button
                    type="button"
                    class="date-picker-btn"
                    [owlDateTimeTrigger]="datePicker"
                    [disabled]="isLocked(dataPoint)
                    "
                  >
                    <img src="../../../assets/calendar.svg" alt=" calendar icon" />
                  </button>
                </div>

                <input [id]="'dp_' + sectionIdx + '_' + dataPoint['dataPointId']" [owlDateTime]="datePicker"
                  style="display: none;" (dateTimeChange)="dataPoint['triggerConditions'] != null ? onDatePickerChange($event, idx, sectionIdx, [dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']]):onDatePickerChange($event, idx, sectionIdx)" />

                <owl-date-time #datePicker [pickerType]="'calendar'"></owl-date-time>

                <button
                  type="button"
                  class="btn-fill"
                  [disabled]="isLocked(dataPoint)"
                  [ngClass]="isLocked(dataPoint) ? 'disabled-btn' : ''"
                  (click)="dataPoint['triggerConditions'] != null ?setCurrentDate(idx, sectionIdx, [dataPoint['dataType'],dataPoint['triggerConditions']['condition'], dataPoint['triggerConditions']['hiddenFieldDataPoint'], sectionIdx, dataPoint['triggerConditions']['value']]) :setCurrentDate(idx, sectionIdx)"
                >
                  Current Date
                </button>
              </div>
            </div>

            <!-- NOTE -->
            <div class="logSheet-form__note" [ngStyle]="{
                'align-self':
                  dataPoint['dataType'] === 'List (Multiple Selection)' ||
                  dataPoint['dataType'] === 'List (Single Selection)' ||
                  dataPoint['dataType'] === 'Text (Long)'
                    ? 'baseline'
                    : 'end',
              }"
            >
              <button
                type="button"
                class="logSheet-form__note-btn"
                (click)="(activeVersion == 0 || runtimeNotesAllowed) ? toggleNoteMenu(idx, sectionIdx) : null"
                [disabled]="activeVersion != 0 && !runtimeNotesAllowed"
              >
                <img
                  class="add-icon"
                  [src]="section.dataPointValues[idx]['note'] ? '../../../assets/edit-pencil.svg' : '../../../assets/logsheet.svg'"
                  alt=" note icon"
                />
              </button>
              <div *ngIf="
                  isNoteMenuVisible &&
                  idx == selectedDataPointIdx &&
                  sectionIdx == selectedSectionIdx
                " class="note-menu">
                <div class="note-menu__header">
                  {{ logSheet?.["logSheetTemplated"]?.["logSheetName"] || section.name || "Note" }}
                </div>
                <button *ngIf="!isEditing(sectionIdx)" type="button" class="note-textBtn" (click)="toggleNoteModal()">
                  <img src="../../../assets/note.svg" alt=" icon" />
                  Add Note
                </button>
                <div *ngIf="isEditing(sectionIdx)">
                  <button type="button" class="note-textBtn" (click)="toggleNoteModal()">
                    <img style="filter: invert() brightness()" src="../../../assets/edit-pencil.svg" alt=" icon" />
                    Edit Note
                  </button>
                  <div class="underline"></div>
                  <button type="button" class="note-textBtn" (click)="showDeactivateModal()">
                    <img src="../../../assets/delete.svg" alt=" icon" />
                    Delete Note
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- ERROR MESSAGE -->
          <div class="error" *ngIf="
              invalidFields[sectionIdx + '_' + idx] &&
              section.dataPointValues[idx]['note'].length === 0
            ">
            <img src="../../assets/alert.svg" alt="" />
            <p>
              {{ invalidFields[sectionIdx + "_" + idx] }}
            </p>
          </div>
        </div>
        </ng-container>
      </div>
    </div>

    <div class="form-actions" *ngIf="!runtimeMode">
    <!-- Add Section Button (only for dynamic forms) -->
    <button
      *ngIf="isDynamicForm && activeVersion == 0"
      type="button"
      class="add-section-btn"
      [disabled]="hasIncompleteUnsubmittedSections() || isAddingSection"
      (click)="
        !hasIncompleteUnsubmittedSections() && !isAddingSection
          ? addSection()
          : null
      ">
      <span *ngIf="isAddingSection" class="spinner-border spinner-border-sm me-2" role="status"
        aria-hidden="true"></span>
      <img *ngIf="!isAddingSection" src="../../../assets/plus.svg" alt="add icon" />
      <!-- Add Section -->
    </button>

    <button
      class="btn-fill logSheet-form-submit-btn"
      [disabled]="!isEnabled() || isSubmitting"
      (click)="isEnabled() && !isSubmitting ? saveLogSheet(false) : null"
    >
      <span
        *ngIf="isSubmitting"
        class="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      Submit<span *ngIf="currentRoute.includes('/forms')">Changes</span>
    </button>
    </div>
</div>

<div *ngIf="showNoteModal" class="modal-backdrop">
  <div class="modal-body">
    <span>{{ !isEditing(selectedSectionIdx) ? "Add" : "Edit" }} note for
      {{ (sections[selectedSectionIdx]?.dataPoints || dataPoints)[selectedDataPointIdx]?.["dataPointName"] }}</span>
    <p>
      {{ !isEditing(selectedSectionIdx) ? "Add" : "Edit" }}
      note below
    </p>
    <textarea [(ngModel)]="note" type="text" rows="6" maxlength="1024" class="custom-input"></textarea>

    <div>
      <button class="btn-outline" (click)="toggleNoteModal()" type="button">
        Cancel
      </button>
      <button (click)="isNoteSubmitBtnEnabled() ? updateNote() : null" [disabled]="!isNoteSubmitBtnEnabled()"
        type="submit" class="btn-fill-yellow" [ngClass]="!isNoteSubmitBtnEnabled() ? 'disabled-btn' : ''">
        Done
      </button>
    </div>
  </div>
</div>
<app-success-toast *ngIf="this.toastService.showToast"></app-success-toast>
<app-deactivate-modal (onCancel)="showDeactivateMenu = false" (onSave)="deleteNote()" actionButtonTitle="Delete"
  *ngIf="showDeactivateMenu" [title]="deactivateText.title" [message1]="deactivateText.message1"
  [message2]="deactivateText.message2" />
<app-deactivate-modal
  *ngIf="showDeleteFormEntryMenu"
  [title]="deleteFormEntry.title"
  [message1]="deleteFormEntry.message1"
  [message2]="deleteFormEntry.message2"
  actionButtonTitle="Delete"
  (onCancel)="showDeleteFormEntryMenu = false"
  (onSave)="confirmDeleteSection()" />
<app-guard-modal
  *ngIf="activeGuard"
  [guard]="activeGuard"
  [message]="activeGuardMessage"
  (onProceed)="onGuardProceed()"
  (onGoBack)="onGuardGoBack()" />

